import { Dialog, DialogContent, Button, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from '@/theme';

interface SavedOrderDialogProps {
  open: boolean;
  onClose: () => void;
  onContinueSaved: () => void;
  onNewOrder: () => void;
}

const SavedOrderDialog: React.FC<SavedOrderDialogProps> = ({
  open,
  onClose,
  onContinueSaved,
  onNewOrder,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: { xs: 2, sm: 4 },
        //   boxShadow: 3,
          position: 'relative',
          minWidth: 340,
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 20,
          right: 20,
          background: colors.primaryOzone500,
          color: '#fff',
          width: 44,
          height: 44,
          zIndex: 2,
          '&:hover': {
            background: '#0059c1',
          },
        }}
      >
        <CloseIcon sx={{ fontSize: 28 }} />
      </IconButton>
      <DialogContent
        sx={{
          pt: 7,
          pb: 4,
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'PF DIN Text Pro',
            fontWeight: 400,
            fontSize: 26,
            color: '#344055',
            textAlign: 'center',
            mb: 4,
            lineHeight: 1.2,
          }}
        >
          This customer has a saved session.<br />
          Would you like to open the saved order or start a new order.
        </Typography>
        <Box sx={{ display: 'flex', gap: 3, width: '100%', justifyContent: 'center' }}>
          <Button
            variant="contained"
            onClick={onContinueSaved}
            sx={{
              background: '#344055',
              color: '#fff',
              fontWeight: 700,
              fontSize: 20,
              borderRadius: 2,
              px: 2,
              py: 2,
              minWidth: 180,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                background: '#232b3b',
              },
            }}
          >
            Continue Saved
          </Button>
          <Button
            variant="contained"
            onClick={onNewOrder}
            sx={{
              background: colors.primaryOzone500,
              color: '#fff',
              fontWeight: 700,
              fontSize: 20,
              borderRadius: 2,
              px: 2,
              py: 2,
              minWidth: 180,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                background: '#0059c1',
              },
            }}
          >
            New Order
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SavedOrderDialog; 